import styled from "styled-components";

export const LanguageSwitcherContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 48px;
`;
